/**
 * @function to get Captcha to all apis
 * @param captchaRequest create session response, host and elements 
 * @returns  api return success and error callback for captcha response
 */

const triggerGetCaptcha = (captchaRequest) => {
    const getCaptchaUrl = `https://${captchaRequest.host}/wuconnect/rest/api/v1.0/GetCaptcha`
    try {
        const reqPayload =
        {
            channel: {
                device_identifier: 'RESPONSIVE_WEB',
                is_responsive: 'true',
                name: 'Western Union',
                type: 'WEB',
                version: '9Z00'
            },
            security: {
                client_ip: captchaRequest?.response?.security?.client_ip ? captchaRequest.response.security.client_ip : '245024209201',
                session: {
                    id: captchaRequest?.response?.security?.session.id
                }
            }
        }

        httpRequest.post(getCaptchaUrl, reqPayload, captchaRequest?.header)
        .then((captchaResponse) => {
            if (!captchaResponse.error) {
                captchaRequest.successCallBack(captchaResponse, captchaRequest);
            } else {
                captchaRequest.errorCallBack(captchaResponse, captchaRequest);
            }
        });

    } catch (error) {
        captchaRequest.errorCallBack(error, captchaRequest);
        console.warn('Error in captcha service', error);
    }

}